// A24.21 scheduled maintenance windows — module-local data layer. REAL backend
// (/admin/maintenance). Informational only (does NOT toggle maintenance_mode);
// the public /status surfaces active + upcoming windows.
import { api } from '@/lib/api'

export interface MaintWindow {
  id: number
  title: string
  message: string
  status: string // scheduled|active|completed|cancelled
  starts_at: string
  ends_at: string
}

const opt = (s?: AbortSignal) => (s ? { signal: s } : undefined)

export const fetchWindows = (s?: AbortSignal) =>
  api.get<{ windows: MaintWindow[] }>('/admin/maintenance', opt(s)).then((d) => d.windows ?? [])
export const createWindow = (title: string, message: string, starts_at: string, ends_at: string) =>
  api.post<{ id: number }>('/admin/maintenance', { title, message, starts_at, ends_at })
export const cancelWindow = (id: number) => api.post(`/admin/maintenance/${id}/cancel`, {})
export const deleteWindow = (id: number) => api.del(`/admin/maintenance/${id}`)

// datetime-local ("YYYY-MM-DDTHH:mm", local tz) → RFC3339 (UTC).
export function toRFC3339(local: string): string | null {
  if (!local) return null
  const d = new Date(local)
  return isNaN(d.getTime()) ? null : d.toISOString()
}

export const MW_STATUS: Record<string, { label: string; pill: string }> = {
  scheduled: { label: 'Запланировано', pill: 'bg-accent/10 text-accent' },
  active: { label: 'Идёт', pill: 'bg-warning/10 text-warning' },
  completed: { label: 'Завершено', pill: 'bg-surface-3 text-tertiary' },
  cancelled: { label: 'Отменено', pill: 'bg-surface-3 text-tertiary' },
}

export const MW_STR = {
  title: 'Техработы (окна)',
  desc: 'Планирование окон техработ — показываются на странице статуса (maintenance_mode не трогает)',
  schedule: 'Запланировать',
  name: 'Заголовок',
  message: 'Сообщение',
  from: 'Начало',
  to: 'Конец',
  cancel: 'Отменить',
  delete: 'Удалить',
  done: 'Готово',
  failed: 'Ошибка',
  empty: 'Нет окон техработ',
  refresh: 'Обновить',
} as const
